import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class ManageUserService {
    constructor() {
        this.addUserSubject = new BehaviorSubject({});
        this.addUserObservable = this.addUserSubject.asObservable();
    }
    setAddUser(user) {
        this.addUserSubject.next(user);
    }
    getAddUser() {
        return this.addUserObservable;
    }
}
ManageUserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ManageUserService_Factory() { return new ManageUserService(); }, token: ManageUserService, providedIn: "root" });
